<template>
  <div id="app" :class="$route.name">
    <!-- start page-wrapper -->
    <div class="page-wrapper">

      <!-- start preloader -->
      <!-- <div class="preloader">
        <div class="sk-cube-grid">
          <div class="sk-cube sk-cube1"></div>
          <div class="sk-cube sk-cube2"></div>
          <div class="sk-cube sk-cube3"></div>
          <div class="sk-cube sk-cube4"></div>
          <div class="sk-cube sk-cube5"></div>
          <div class="sk-cube sk-cube6"></div>
          <div class="sk-cube sk-cube7"></div>
          <div class="sk-cube sk-cube8"></div>
          <div class="sk-cube sk-cube9"></div>
        </div>
      </div> -->
      <!-- end preloader -->

      <!-- Start header -->
      <header id="header" class="site-header header-style-1">
        <div class="topbar hidden-xs visible-md visible-lg">
          <div class="container">
            <div class="row">
              <div class="col-xs-11 col-md-12">
                <div class="row">
                  <div class="col col-md-10 col-xs-9">
                    <div class="contact-info">
                      <ul>
                        <li><i class="ti-location-pin"></i>4745 West Marginal Way SW. Seattle WA 98106</li>
                        <li><i class="ti-mobile"></i> (206) 453-3168</li>
                        <li class="hidden-xs  visible-md visible-lg "><i class="ti-email "></i> tellmemore@streamlineinstall.com</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col col-xs-11 col-md-2 hidden-xs visible-md visible-lg">
                    <div class="social-links">
                      <ul>
                        <li><a href="https://www.linkedin.com/company/streamline-solutions_4/about/" target="_blank"><i class="ti-linkedin"></i></a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xs-1">


                  </div>
                </div>
              </div>



            </div>
          </div> <!-- end container -->
        </div> <!-- end topbar -->

        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-md-4 logo-wrapper">
              <router-link class="navbar-brand logo-dark" :to="{name: 'home'}"><img src="assets/images/logo-dark.png" alt></router-link>
              <router-link class="navbar-brand logo-light" :to="{name: 'home'}"><img src="assets/images/logo.png" alt></router-link>
            </div>
            <div class="col-md-8">
              <div class="navbar-header  ">
                <button type="button" @click="menuVisible = true" class="open-btn">
                  <span class="sr-only">Toggle navigation</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
              </div>
              <div id="navbar" class="navbar-collapse collapse navbar-right navigation-holder" :class="navBarClass">
                <div class="d-flex mb-2 mt-2 d-flex justify-content-end mr-2">
                  <button @click="hideNav" class="hidden-md hidden-lg "><i class="ti-close"></i></button>
                </div>

                <ul class="nav navbar-nav">
                  <li @click="hideNav" :class="$route.path === '/'? 'current-menu-parent':'' " >
                    <router-link  :to="{name: 'home'}">Home</router-link>
                  </li>
                  <li @click="hideNav" :class="$route.path === '/services'? 'current-menu-parent':'' ">
                    <router-link to="/services">Our Services</router-link>
                  </li>
                  <li @click="hideNav" :class="$route.path === '/about-our-team'? 'current-menu-parent':'' ">
                    <router-link to="/about-our-team">Our Team</router-link>
                  </li>
                  <li @click="hideNav" :class="$route.path.includes('/case-studies') ? 'current-menu-parent':'' ">
                    <router-link to="/case-studies">Case Studies</router-link>

                  </li>
                  <li @click="hideNav" :class="$route.path === '/contact-us'? 'current-menu-parent':'' " >
                    <router-link to="/contact-us">Contact Us</router-link>
                  </li>

                </ul>
              </div><!-- end of nav-collapse -->
            </div>

          </div>
        </div>


      </header>
      <!-- end of header -->


      <router-view></router-view>


      <!-- start site-footer -->
      <footer class="site-footer">
        <div class="upper-footer">
          <div class="container">
            <div class="row">
              <div class="col col-lg-4 col-md-3 col-sm-6">
                <div class="widget about-widget">

                  <div class="widget-title">
                    <h4 >Audio Visual Design & Install</h4>
                    <p>
                      We work closely with interior designers and architects to ensure that the audio visual system is seamlessly integrated into the working environment. Our knowledgeable and professional team has thousands of hours of design and installation experience.
                    </p>
                  </div>
                  <div class="social-icons">
                    <ul>
                      <li><a href="https://www.linkedin.com/company/streamline-solutions_4/about/" target="_blank"><i class="ti-linkedin"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 col-md-3 col-sm-6">
                <div class="widget about-widget">

                  <div class="widget-title">
                    <h4>Affiliation and Membership</h4>
                    <p>
                      Streamline is proud to be an active, contributing member of the following affiliations and organizations:
                    </p>
                    <ul>
                      <li>GeekWire</li>
                      <li>InfoComm</li>
                      <li>Crew Network</li>
                    </ul>
                  </div>
                </div>
              </div>



              <div class="col col-lg-4 col-md-3 col-sm-6">
                <div class="widget contact-widget">
                  <div class="widget-title">
                    <h3>Contact Details</h3>
                  </div>
                  <ul>
                    <li>4745 West Marginal Way SW. Seattle WA 98106</li>
                    <li><span class="text-white">Email: </span> tellmemore@streamlineinstall.com</li>
                    <li><span class="text-white">Phone: </span> (206) 453-3168</li>
                    <li><span class="text-white">Fax: </span> (206) 453-3394</li>
                  </ul>
                </div>
              </div>
            </div>
          </div> <!-- end container -->
        </div>
        <div class="lower-footer">
          <div class="container">
            <div class="row">
              <div class="separator"></div>
              <div class="col col-xs-12">
                <p class="copyright">Copyright &copy; 2018 Streamline Solutions. All rights reserved.</p>
                <ul>
                  <li><a href="https://www.humanity.com/app/" target="_blank">Tech Login</a></li>
                  <li><router-link :to="{name: 'caseStudy'}">Case Studies</router-link></li>
                  <li><router-link :to="{name: 'contact-us'}">Contact Us</router-link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <!-- end site-footer -->

    </div>
    <!-- end of page-wrapper -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuVisible: false
    }
  },
  computed: {
    navBarClass() {
      return this.menuVisible ? 'slideInn' : 'slideOut';
    }
  },
  methods: {
    hideNav(e){
      this.menuVisible = false;
    }
  }
}
</script>
<style lang="scss">
  @import '@/assets/sass/style.scss';
.text-white {
  color: #fff !important;
}
</style>
